import { z } from 'zod';
import { ExpenseCategoryKind, Locale } from '../enums.js';

const hhmm = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);

export const WorkingHoursSchema = z.object({
  days: z.array(z.number().int().min(0).max(6)).min(1).max(7),
  from: hhmm,
  to: hhmm,
});

export const TenantSettingsPatchSchema = z
  .object({
    workingHours: WorkingHoursSchema,
    speedLimits: z.object({
      defaultKph: z.number().int().min(20).max(200),
      byType: z.record(z.number().int().min(20).max(200)),
    }),
    offlineMinutes: z.number().int().min(1).max(1440),
    idleMinutes: z.number().int().min(1).max(120),
    stopMinutes: z.number().int().min(1).max(120),
    jitterM: z.number().int().min(0).max(100),
    obdStaleSec: z.number().int().min(30).max(3600),
    phoneStaleSec: z.number().int().min(30).max(3600),
    maxSpeedKph: z.number().int().min(60).max(300),
    phone: z.object({
      intervalMovingSec: z.number().int().min(5).max(300),
      intervalStoppedSec: z.number().int().min(30).max(3600),
      minDistanceM: z.number().int().min(0).max(500),
      batchMaxAgeSec: z.number().int().min(10).max(600),
    }),
    numbering: z.object({
      trip: z.string().min(1).max(6),
      expense: z.string().min(1).max(6),
      invoice: z.string().min(1).max(6),
      workOrder: z.string().min(1).max(6),
    }),
    vatRatePct: z.number().min(0).max(100),
    cargoTypes: z.array(z.string().min(1).max(60)).max(50),
  })
  .partial();
export type TenantSettingsPatch = z.infer<typeof TenantSettingsPatchSchema>;

export const CompanyProfilePatchSchema = z.object({
  nameAr: z.string().min(2).max(120).optional(),
  nameEn: z.string().min(2).max(120).nullable().optional(),
  timezone: z.string().optional(),
  locale: z.enum(Locale).optional(),
  currency: z.string().length(3).optional(),
  logoFileId: z.string().uuid().nullable().optional(),
});
export type CompanyProfilePatch = z.infer<typeof CompanyProfilePatchSchema>;

export const ExpenseCategoryInputSchema = z.object({
  kind: z.enum(ExpenseCategoryKind),
  nameAr: z.string().min(1).max(60),
  nameEn: z.string().min(1).max(60),
  isFuel: z.boolean().default(false),
  isActive: z.boolean().default(true),
  sortOrder: z.number().int().min(0).default(0),
});
export type ExpenseCategoryInput = z.infer<typeof ExpenseCategoryInputSchema>;
